module.exports = __webpack_public_path__ + "media/winter_2025_sweepstakes/answer-647b7205.svg";